<script>
import 'vue-select/dist/vue-select.css'
import Multiselect from 'vue-multiselect'
import { axiosGetPost } from '@router/axiosGetPost'
import 'vue2-datepicker/index.css'
import { required, decimal } from 'vuelidate/lib/validators'
import integer from 'vuelidate/lib/validators/integer'
import DateRangePicker from 'vue2-daterange-picker'
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'
import { formatDate, parseDate } from '@router/date-utils'

const notNull = (value) => {
  return value.id !== null
}

const listNotNull = (list) => {
  if (list.length === 0) {
    return false
  }
  return list.every((value) => value.id !== null)
}

const validateDateRange = (dateRange) => {
  let date = [dateRange.startDate, dateRange.endDate]
  return !(date[0] != '1970-01-01' && date[1] != '1970-01-01')
}

export default {
  name: 'EditFailLocalCharge',
  components: {
    Multiselect,
    DateRangePicker,
  },
  props: {
    localId: { type: [String, Number], default: null },
  },
  data() {
    return {
      locationOptions: [
        { text: 'Port', value: 'port' },
        { text: 'Country', value: 'country' },
        { text: 'Port Country', value: 'port-country' },
        { text: 'Country Port', value: 'country-port' },
      ],
      companyUsers: [],
      chargers: [],
      ports: [],
      countries: [],
      origins: [],
      destinations: [],
      typeDestinations: [],
      calculationTypes: [],
      currencies: [],
      carriers: [],
      location: '',
      disabledOrigin: false,
      disabledDestiny: false,
      labelLocation: ['', ''],
      portAll: [{ id: 1485, name: 'ALL' }],
      countryAll: [{ id: 250, name: 'ALL' }],
      selectedOptions: {
        allOrigin: false,
        allDestiny: false,
        location: '',
        companyUser: {},
        charge: {},
        origin: [],
        destiny: [],
        calculationType: {},
        typeDestination: {},
        validation: { startDate: null, endDate: null },
        currency: {},
        carrier: [],
        amount: 0,
        originException: [],
        destinyException: [],
      },
      rawData: {},
      originExceptionShow: true,
      destinyExceptionShow: true,
      typeException: 'port',
      counter: false,
      loadingData: true,
      errorShow: false,
      error: '',
    }
  },
  validations: {
    selectedOptions: {
      companyUser: { required, notNull },
      charge: { required, notNull },
      origin: { required, listNotNull },
      destiny: { required, listNotNull },
      calculationType: { required, notNull },
      typeDestination: { required, notNull },
      validation: { required },
      currency: { required, notNull },
      carrier: { required, listNotNull },
      amount: {
        decimal,
        minValue: (value) => {
          return value >= 1.0
        },
      },
    },
  },
  watch: {
    location() {
      this.locationSetting()
    },
    'selectedOptions.allOrigin': {
      handler() {
        if (!this.selectedOptions.allOrigin) {
          this.selectedOptions.originException = []
        }
      },
      immediate: true,
    },
    'selectedOptions.allDestiny': {
      handler() {
        if (!this.selectedOptions.allDestiny) {
          this.selectedOptions.destinyException = []
        }
      },
      immediate: true,
    },
  },

  computed: {},
  created() {
    this.getData()
    this.location = 'port'
  },
  mounted() {},

  methods: {
    loadDataSelects(data) {
      this.ports = data.ports
      this.countries = data.countries
      this.typeDestinations = data.type_destiny
      this.calculationTypes = data.calculation_type
      this.currencies = data.currencies
      this.companyUsers = data.company_users
      this.carriers = data.carriers
      this.chargers = data.chargers
    },
    validateDate(date) {
      return date.toString().includes('_E_E') !== true
    },
    synchronizeData(data) {
      this.selectedOptions.companyUser = data.company_user
      this.selectedOptions.charge = data.charge
      this.selectedOptions.typeDestination = data.type_destiny
      this.selectedOptions.calculationType = data.calculation_type
      this.selectedOptions.currency = data.currency
      this.selectedOptions.amount = data.amount
      this.selectedOptions.carrier = data.carrier
      this.selectedOptions.location = data.location
      this.selectedOptions.origin = data.origin
      this.selectedOptions.destiny = data.destiny
      this.selectedOptions.originException = data.origin_exception
      this.selectedOptions.destinyException = data.destiny_exception
      if (this.validateDate(data.validity) && this.validateDate(data.expire)) {
        this.selectedOptions.validation = {
          startDate: parseDate(data.validity),
          endDate: parseDate(data.expire),
        }
      }
    },
    getData() {
      this.loadingData = true
      axiosGetPost(
        'get',
        '/localCharges/getFailLocalchargeData/' + this.localId,
        {},
        'Get Fail Localcharge Data FCL'
      ).then((response) => {
        const data = response.data
        this.rawData = data.raw
        this.loadDataSelects(data['selects'])
        this.counter = false
        this.location = data['local'].location
        this.selectedOptions.location = data['local'].location
        this.locationSetting_hold()
        this.synchronizeData(data['local'])
        this.selectedOptions.allOrigin = this.verificationAllPlaces('origin')
        this.selectedOptions.allDestiny = this.verificationAllPlaces('destiny')
        this.validate_fields(false)
        this.loadingData = false
        //this.counter = true
        return data
      })
    },
    locationSetting_hold() {
      switch (this.location) {
        case 'port':
          this.labelLocation = ['Port', 'Port']
          this.origins = this.ports
          this.destinations = this.ports
          break
        case 'country':
          this.labelLocation = ['Country', 'Country']
          this.origins = this.countries
          this.destinations = this.countries
          break
        case 'port-country':
          this.labelLocation = ['Port', 'Country']
          this.origins = this.ports
          this.destinations = this.countries
          break
        case 'country-port':
          this.labelLocation = ['Country', 'Port']
          this.origins = this.countries
          this.destinations = this.ports
          break
        default:
          console.log(`Sorry, we are out of ${this.location}.`)
      }
    },
    verificationAllPlaces(place) {
      let result = false
      if (this.selectedOptions[place].length === 0) {
        return result
      } else if (
        [this.portAll[0].id, this.countryAll[0].id].includes(
          this.selectedOptions[place][0].id
        ) == true
      ) {
        result = true
      }
      return result
    },
    locationSetting() {
      this.locationSetting_hold()
      if (this.counter == true) {
        this.locationAllSetting()
        this.selectedOptions.allOrigin = false
        this.selectedOptions.allDestiny = false
        this.cleanLocationsSelects()
      }
      this.counter = true
      this.selectedOptions.location = this.location
    },
    locationAllSetting(typeLocation) {
      let sO = 'selectedOptions'
      let keyLc = typeLocation == 'origin' ? 'origin' : 'destiny'
      let typAll = typeLocation == 'origin' ? 'allOrigin' : 'allDestiny'
      if (!this[sO][typAll]) {
        switch (this.location) {
          case 'port':
            this[sO][keyLc] = this.portAll
            break
          case 'country':
            this[sO][keyLc] = this.countryAll
            break
          case 'port-country':
            this[sO][keyLc] =
              typeLocation == 'origin' ? this.portAll : this.countryAll
            break
          case 'country-port':
            this[sO][keyLc] =
              typeLocation == 'origin' ? this.countryAll : this.portAll
            break
          default:
            console.log(`Sorry, we are out of ${this.location}.`)
        }
      } else {
        this[sO][keyLc] = []
      }
    },
    cleanLocationsSelects() {
      this.selectedOptions.origin = []
      this.selectedOptions.destiny = []
      this.selectedOptions.originException = []
      this.selectedOptions.destinyException = []
    },
    loadTypeCharge() {
      axiosGetPost(
        'put',
        '/localCharges/getSelects',
        {
          company_user: this.selectedOptions.companyUser['id'],
        },
        'Load charge by company - Edit fail Local charge'
      ).then((response) => {
        this.selectedOptions.charge = {}
        const data = response.data
        this.chargers = data.chargers
        return data
      })
    },
    validate_fields(is_submit) {
      let response = true
      this.$v.$touch()
      if (this.$v.$invalid) {
        if (is_submit) {
          this.$toastr.e('Field is required')
        }
        response = false
      }
      return response
    },

    validateDateRange(date) {
      return !(date[0] != '1970-01-01' && date[1] != '1970-01-01')
    },
    save_local() {
      if (this.validate_fields(true)) {
        let pdata = this.selectedOptions
        let date = formatDate(this.selectedOptions.validation)
        if (this.validateDateRange(date) == true) {
          this.$toastr.e('Date range is invalid')
          return
        }
        console.log(date)
        this.loadingData = true
        axiosGetPost(
          'post',
          '/localCharges/updateFailToGood',
          {
            company_user: pdata.companyUser,
            charge: pdata.charge,
            origin: pdata.origin,
            destiny: pdata.destiny,
            calculation_type: pdata.calculationType,
            type_destination: pdata.typeDestination,
            validation: date,
            currency: pdata.currency,
            carrier: pdata.carrier,
            amount: pdata.amount,
            location: pdata.location,
            origin_exception: pdata.originException,
            destiny_exception: pdata.destinyException,
            account_id: this.rawData.account_id,
            local_id: this.localId,
          },
          'Add - Fail to good Local Charge FCL'
        ).then((response) => {
          this.loadingData = false
          console.log(response)
          if (response.success) {
            this.$toastr.s('Updated Local Charge FCL')
            this.$emit('closeModal')
          } else {
            this.errorShow = true
            this.error = 'Error to save'
            this.$toastr.e('Error to save')
            this.$emit('closeModal')
          }
          return response
        })
      }
    },
  },
}
</script>

<template>
  <div>
    <div class="row">
      <div class="col-12">
        <div class="col-md col-md-12">
          <div
            v-if="loadingData"
            class="row align-items-center justify-content-center"
            style="height: 300px"
          >
            <div class="col-12 col-md-8 text-center">
              <b-spinner
                label="Loading..."
                variant="primary"
                class="ml-3"
              ></b-spinner>
            </div>
          </div>

          <div v-else-if="errorShow === true">
            <div
              class="row align-items-center justify-content-center"
              style="height: 300px"
            >
              <div class="col-12 col-md-8 text-center">
                <feather type="frown" class="icon-xxl icon-dual-info"></feather>
                <h6 class="text-muted">{{ error }}</h6>
              </div>
            </div>
          </div>
          <div v-else-if="!loadingData">
            <div class="form-group row">
              <div class="col-sm-7">
                <label for="">Locations Options</label>
                <b-form-group v-slot="{ ariaDescribedby }">
                  <b-form-radio-group
                    id="radio-group-1"
                    v-model="location"
                    :options="locationOptions"
                    :aria-describedby="ariaDescribedby"
                    name="radio-options"
                    class="mt-2 mt-sm-2"
                  >
                  </b-form-radio-group>
                </b-form-group>
              </div>
              <div class="col-md-5">
                <label>Company User</label>
                <multiselect
                  id="companyUser"
                  v-model="selectedOptions.companyUser"
                  :options="companyUsers"
                  select-label=""
                  placeholder="Select one"
                  label="name"
                  track-by="name"
                  :title="rawData.company_user"
                  @input="loadTypeCharge"
                  class="mt-0 mt-sm-0 mb-0"
                  required
                >
                </multiselect>
                <div
                  v-if="$v.selectedOptions.companyUser.$error"
                  style="color: red"
                  >* This value is required.</div
                >
              </div>
            </div>

            <div class="form-group row">
              <div class="col-md-4">
                <label>Type</label>
                <multiselect
                  id="charge"
                  v-model="selectedOptions.charge"
                  :options="chargers"
                  select-label=""
                  placeholder="Select one"
                  label="name"
                  :title="rawData.charge"
                  track-by="name"
                  class="mt-0 mt-sm-0 mb-0"
                  required
                >
                </multiselect>
                <div v-if="$v.selectedOptions.charge.$error" style="color: red"
                  >* This value is required.</div
                >
              </div>
              <div class="col-md-4">
                <b-form-checkbox
                  v-model="selectedOptions.allOrigin"
                  name="check-button"
                  switch
                  @change="locationAllSetting('origin')"
                  class="mb-2"
                >
                  <span style="color: blue"> ALL </span> - Origin
                  {{ labelLocation[0] }}
                </b-form-checkbox>
                <multiselect
                  id="origin"
                  v-model="selectedOptions.origin"
                  :options="origins"
                  :multiple="true"
                  select-label=""
                  placeholder="Select one"
                  label="name"
                  track-by="name"
                  :title="rawData.origin"
                  :disabled="selectedOptions.allOrigin"
                  class="mt-0 mt-sm-0 mb-0"
                >
                </multiselect>
                <div v-if="$v.selectedOptions.origin.$error" style="color: red">
                  * This value is required.
                </div>
              </div>
              <div class="col-md-4">
                <b-form-checkbox
                  v-model="selectedOptions.allDestiny"
                  name="check-button"
                  switch
                  @change="locationAllSetting('destiny')"
                  class="mb-2"
                >
                  <span style="color: blue"> ALL </span> - Destination
                  {{ labelLocation[1] }}
                </b-form-checkbox>
                <multiselect
                  id="destiny"
                  v-model="selectedOptions.destiny"
                  :options="destinations"
                  :multiple="true"
                  select-label=""
                  placeholder="Select one"
                  label="name"
                  track-by="name"
                  :title="rawData.destiny"
                  :disabled="selectedOptions.allDestiny"
                  aria-readonly="true"
                  class="mt-0 mt-sm-0 mb-0"
                >
                </multiselect>
                <div
                  v-if="$v.selectedOptions.destiny.$error"
                  style="color: red"
                >
                  * This value is required.
                </div>
              </div>
            </div>

            <div class="form-group row">
              <div class="col-md-4">
                <label>Destination Type</label>
                <multiselect
                  id="typeDestiny"
                  v-model="selectedOptions.typeDestination"
                  :options="typeDestinations"
                  select-label=""
                  :title="rawData.type_destiny"
                  placeholder="Select one"
                  label="name"
                  track-by="name"
                  class="mt-0 mt-sm-0 mb-0"
                >
                </multiselect>
                <div
                  v-if="$v.selectedOptions.typeDestination.$error"
                  style="color: red"
                >
                  * This value is required.
                </div>
              </div>
              <div class="col-md-4">
                <label>Validation</label>
                <!-- <date-picker
                  v-model="selectedOptions.validation"
                  :title="rawData.validation"
                  class="col-md-12"
                  type="date"
                  range
                  placeholder="Select date range"
                >
                </date-picker> -->
                <date-range-picker
                  opens="center"
                  :locale-data="{
                    format: 'yyyy-mm-dd',
                    separator: ' / ',
                    direction: 'ltr',
                  }"
                  class="col-md-12"
                  v-model="selectedOptions.validation"
                  timezone="local"
                >
                </date-range-picker>
                <div
                  v-if="$v.selectedOptions.validation.$error"
                  style="color: red"
                >
                  * This value is required.
                </div>
              </div>
              <div class="col-md-4">
                <label>Calculation Type</label>
                <multiselect
                  id="calculationT"
                  v-model="selectedOptions.calculationType"
                  :options="calculationTypes"
                  select-label=""
                  placeholder="Select one"
                  :title="rawData.calculation_type"
                  label="name"
                  track-by="name"
                  class="mt-0 mt-sm-0 mb-0"
                >
                </multiselect>
                <div
                  v-if="$v.selectedOptions.calculationType.$error"
                  style="color: red"
                >
                  * This value is required.
                </div>
              </div>
            </div>

            <div class="form-group row">
              <div class="col-md-4">
                <label>Carrier</label>
                <multiselect
                  id="carrier"
                  v-model="selectedOptions.carrier"
                  :options="carriers"
                  select-label=""
                  :multiple="true"
                  placeholder="Select one"
                  :title="rawData.carrier"
                  label="name"
                  track-by="name"
                  class="mt-0 mt-sm-0 mb-0"
                >
                </multiselect>
                <div
                  v-if="$v.selectedOptions.carrier.$error"
                  style="color: red"
                >
                  * This value is required.
                </div>
              </div>
              <div class="col-md-4">
                <label>Currency</label>
                <multiselect
                  id="currency"
                  v-model="selectedOptions.currency"
                  :options="currencies"
                  select-label=""
                  placeholder="Select one"
                  label="name"
                  :title="rawData.currency"
                  track-by="name"
                  class="mt-0 mt-sm-0 mb-0"
                >
                </multiselect>
                <div
                  v-if="$v.selectedOptions.currency.$error"
                  style="color: red"
                >
                  * This value is required.
                </div>
              </div>
              <div class="col-md-4">
                <label>Amount</label>
                <b-form-input
                  id="name"
                  v-model="selectedOptions.amount"
                  min="0.0"
                  step="0.01"
                  type="number"
                  value
                  placeholder="Write amount"
                  :title="rawData.amount"
                  required
                >
                </b-form-input>
                <div v-if="$v.selectedOptions.amount.$error" style="color: red">
                  * This value is required.
                </div>
              </div>
            </div>
            <hr />
            <div class="form-group row">
              <div v-if="selectedOptions.allOrigin" class="col-md-6">
                <label>Exception Origin - {{ labelLocation[0] }}</label>
                <multiselect
                  id="carrier"
                  v-model="selectedOptions.originException"
                  :options="origins"
                  select-label=""
                  :multiple="true"
                  placeholder="Select one"
                  label="name"
                  track-by="name"
                  class="mt-0 mt-sm-0 mb-0"
                >
                </multiselect>
              </div>
              <div v-if="selectedOptions.allDestiny" class="col-md-6">
                <label>Exception Destiny - {{ labelLocation[1] }}</label>
                <multiselect
                  id="carrier"
                  v-model="selectedOptions.destinyException"
                  :options="destinations"
                  select-label=""
                  :multiple="true"
                  placeholder="Select one"
                  label="name"
                  track-by="name"
                  class="mt-0 mt-sm-0 mb-0"
                >
                </multiselect>
              </div>
            </div>
            <div class="row">
              <div class="col-12 text-center mt-3">
                <!-- Asegúrate de añadir un margen en la parte superior para separar el botón del último elemento de tu formulario -->
                <b-button variant="primary" class="col-4" @click="save_local"
                  >Submit</b-button
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.center {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh; /* O puedes cambiarlo a la altura que prefieras */
}
</style>